import type { ResponseMerchFlowDetails } from "@CommonApi/merchandise";
import type { OptionalPaginationQueryParams, Pagination } from "@CommonTypes/backend/pagination";
import type { ReviewStatus } from "@CommonTypes/merchflow/ReviewStatus";

export const RouteGetMerchflowsReviews = "/merchflows/reviews";

export type FlowReviewSortableColumn =
  | "id"
  | "name"
  | "status"
  | "category_code"
  | "retailer_category_code"
  | "go_live_date"
  | "created_at"
  | "updated_at"
  | "deactivation_date";

export type ParamsGetMerchflowsReviews = OptionalPaginationQueryParams & {
  id?: number;
  name?: string;
  status?: ReviewStatus | ReviewStatus[] | string;
  category?: string | string[];
  subcategory?: string | string[];
  goLiveDateFrom?: string;
  goLiveDateTo?: string;
  dateCreatedFrom?: string;
  dateCreatedTo?: string;
  dateModifiedFrom?: string;
  dateModifiedTo?: string;
  deactivationDateFrom?: string;
  deactivationDateTo?: string;
  sortBy?: FlowReviewSortableColumn;
  sortDirection?: "asc" | "desc";
};

export type ResponseGetMerchflowsReviews = Pagination<ResponseMerchFlowDetails>;
